var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4,8a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.42L4.59,5H1A1,1,0,0,1,1,3H4.59L3.29,1.71A1,1,0,0,1,4.71.29l3,3a1,1,0,0,1,.21.33A1,1,0,0,1,8,4H8a1,1,0,0,1-.08.38,1,1,0,0,1-.21.33l-3,3A1,1,0,0,1,4,8Z"}));
}

ArrowRight.defaultProps = {"width":"8","height":"8","viewBox":"0 0 8 8"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
